import { AnimatePresence, motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import { FADE_IN_OUT } from '@/utils';

type Props = PropsWithChildren<{
  isLoaded?: boolean;
}>;

export const AnimatePresenceComponent = ({
  children,
  isLoaded = false,
}: Props) => {
  return (
    <AnimatePresence initial={isLoaded}>
      {isLoaded && (
        <motion.div animate={'show'} initial="hide" variants={FADE_IN_OUT}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
